import React, { useState } from "react";
import axios from "axios";
import { Button } from "semantic-ui-react";

export default function DownloadPricebookButton({
  dealerId,
  dealerName,
  style,
}) {
  const [isLoading, setLoading] = useState(false);
  if (!dealerId) return null;

  const filename = `${dealerName}-${new Date().toLocaleDateString()}`;

  function onClick() {
    const req = { dealer_id: dealerId };

    setLoading(true);

    axios({
      method: "post",
      url: `/pricebook-pdf/`,
      data: req,
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    })
      .then(({ data }) => {
        const blob = new Blob([data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${filename}.pdf`;
        link.click();
      })
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  return (
    <Button
      icon="download"
      size="tiny"
      content="Download Pricebook"
      style={style}
      onClick={onClick}
      loading={isLoading}
      disabled={isLoading}
    />
  );
}

DownloadPricebookButton.defaultProps = {
  dealerId: null,
  dealerName: "Pricebook",
  style: { marginTop: "10px" },
};
